<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M2.251,23.249c-0.379,0-0.755-0.097-1.087-0.28c-1.086-0.6-1.482-1.971-0.882-3.057l9.747-17.995
		c0.207-0.376,0.512-0.681,0.884-0.887c0.334-0.184,0.709-0.281,1.086-0.281c0.211,0,0.421,0.03,0.626,0.089
		c0.578,0.166,1.056,0.548,1.346,1.074l9.753,18.005c0.181,0.328,0.277,0.703,0.277,1.082c0,1.241-1.009,2.25-2.25,2.25H2.251z
		 M12,2.249c-0.127,0-0.248,0.032-0.361,0.094c-0.124,0.068-0.225,0.17-0.294,0.294L1.598,20.632
		c-0.099,0.179-0.122,0.382-0.066,0.575c0.056,0.193,0.182,0.352,0.357,0.449c0.111,0.061,0.236,0.094,0.362,0.094h19.5
		c0.414,0,0.75-0.337,0.75-0.75c0-0.126-0.032-0.251-0.094-0.362L12.655,2.633c-0.095-0.172-0.254-0.299-0.446-0.354
		C12.14,2.259,12.07,2.249,12,2.249z"/>
	<path d="M12.001,19.499c-0.044,0-0.088-0.004-0.13-0.011c-0.513-0.06-0.923-0.47-0.983-0.983c-0.008-0.043-0.012-0.087-0.012-0.131
		s0.004-0.088,0.012-0.131c0.06-0.513,0.47-0.922,0.983-0.982c0.042-0.008,0.086-0.011,0.131-0.011s0.088,0.004,0.13,0.011
		c0.513,0.06,0.923,0.47,0.983,0.983c0.008,0.042,0.011,0.086,0.011,0.131s-0.004,0.088-0.011,0.131
		c-0.06,0.513-0.47,0.923-0.983,0.983C12.089,19.496,12.046,19.499,12.001,19.499z"/>
	<path d="M12.001,15.749c-0.414,0-0.75-0.336-0.75-0.75v-6.75c0-0.414,0.336-0.75,0.75-0.75c0.413,0,0.75,0.336,0.75,0.75v6.75
		C12.751,15.413,12.415,15.749,12.001,15.749z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'road-sign-warning',
    },
    name: {
      type: String,
      required: false,
      default: 'RoadSignWarning',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>